import { GameGoalFlag, GameScoreEnum } from '../../Game/Enums';
import { playerSettings } from '../../GameKit/shared';
import gameKit from '../../GameKit';

const playerDefaultState = {
    hat: playerSettings.hatDefault,
    texture: playerSettings.textureDefault,
    lives: playerSettings.livesDefault,
    weight: playerSettings.weightDefault,
    bounce: playerSettings.bounceDefault,
    textureHue: playerSettings.textureHue
};

const defaultState = {
    title: '',
    description: '',
    goal: GameGoalFlag.FINISH,
    score: GameScoreEnum.NONE,
    levels: [], // { string uuid: level-uuid, string thumbnail: DataURL, string description: description }
    thumbnail: undefined, // string uuid: level-uuid
    player: playerDefaultState,
    loadingProgress: 0,
    loadingText: 'Er gaat iets fout! Probeer de pagina te verversen.',
    loadingComplete: false
};

export function findLevelByUuid(levels, uuid) {
    for (let i = 0; i < levels.length; ++i) {
        if (levels[i].uuid === uuid) {
            return i;
        }
    }
    return -1;
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'GAME_UPDATE_LOADING_PROGRESS': {
            const { payload } = action;
            return {
                ...state,
                loadingProgress: payload.progress,
                loadingText: payload.text
            };
        }
        case 'GAME_SET_LOADING_COMPLETE': {
            const { payload } = action;
            return {
                ...state,
                loadingComplete: payload
            }
        }
        case 'GAME_UPDATE_SETTINGS': {
            // 'GAME_UPDATE_SETTINGS' expects to have all settings available in the payload
            const { payload } = action;
            const newScore = GameScoreEnum.checkOOB(payload.score);

            return {
                ...state,
                title: payload.title,
                description: payload.description,
                goal: payload.goal,
                score: newScore
            };
        }
        case 'GAME_UPDATE_PLAYER_SETTINGS': {
            // 'GAME_UPDATE_PLAYER_SETTINGS' expects to have all settings available in the payload
            const { payload } = action;
            payload.bounce = playerSettings.denormalizeBounce(payload.bounce);

            return {
                ...state,
                player: payload
            };
        }
        case 'GAME_CREATE_LEVEL': {
            const newLevels = state.levels;
            const { payload } = action;

            const newLevel = gameKit.getLevel(payload);

            newLevels.push({
                uuid: payload,
                thumbnail: undefined,
                description: newLevel.description
            });

            return {
                ...state,
                levels: newLevels
            };
        }
        case 'GAME_MOVE_LEVEL': {
            const newLevels = state.levels;
            const { payload } = action;
            const { idxToMove, idxToReplace } = payload;

            newLevels.splice(idxToReplace, 0, newLevels.splice(idxToMove, 1)[0]);

            return {
                ...state,
                levels: newLevels
            };
        }
        case 'GAME_DELETE_LEVEL': {
            const newLevels = state.levels;
            const { payload } = action;

            const i = findLevelByUuid(newLevels, payload);
            if (i >= 0) {
                newLevels.splice(i, 1);
            }

            return {
                ...state,
                levels: newLevels
            };
        }
        case 'GAME_UPDATE_THUMBNAIL': {
            const newLevels = state.levels;
            const { payload } = action;
            const { uuid, url } = payload;

            const i = findLevelByUuid(newLevels, uuid);
            if (i >= 0) {
                newLevels[i].thumbnail = url;
            }

            return {
                ...state,
                levels: newLevels
            };
        }
        case 'GAME_UPDATE_DESC': {
            const { payload } = action;
            const { uuid, desc } = payload;

            const i = findLevelByUuid(state.levels, uuid);
            if (i >= 0) {
                const newLevels = state.levels;
                newLevels[i].description = desc;
                return {
                    ...state,
                    levels: newLevels
                };
            }
            return state;
        }
        case 'GAME_SET_GAME_THUMBNAIL': {
            const { payload } = action;
            const { uuid } = payload;

            const i = findLevelByUuid(state.levels, uuid);
            if (i >= 0) {
                return {
                    ...state,
                    thumbnail: uuid
                };
            }
            
            if(uuid === undefined || uuid === null) {
                return {
                    ...state,
                    thumbnail: undefined
                };
            }

            return state;
        }
        default: {
            return state;
        }
    }
}
